document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener('scroll', function() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollThreshold = pageHeight * 0.2;

        const element = document.querySelector('.add-to-cart-action-wrap');

        if (element) {
            if (scrollPosition > scrollThreshold) {
                element.classList.add('scrolled');
            } else {
                element.classList.remove('scrolled');
            }
        }
    });
});